import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import { LinearProgress, Typography, useMediaQuery, useTheme } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useUrlChecker } from '@/hooks/useUrlChecker';
import { externalConnections, routes } from '@/constants/Constants';
import { MobileMenuV1 as MobileMenu } from '@/appWrapper/SideMenu';
import useProgressStore from '@/stores/progressStore';
import { Link } from '@/components/Link';
import { useSmartBack } from '@/shared/hooks';
import HeaderLogo from './HeaderLogo';

const SiteHeader = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { isSigningUp, isPublic } = useUrlChecker();
  const preRegister = isPublic || window.location.pathname === routes.unitsOwnedEnroll;
  const handleBack = useSmartBack({ fallbackPath: routes.home });

  const { progress } = useProgressStore();

  return (
    <Box sx={{ minHeight: { xs: '100px', sm: '148px' } }}>
      <LinearProgress
        sx={{ display: progress ? 'fixed' : 'none', position: 'fixed' }}
        value={progress}
      />
      <AppBar sx={{ mx: { lg: isPublic ? '20px' : 0 } }}>
        <Toolbar>
          <Box sx={{ flex: 1, display: 'flex', alignItems: 'center' }}>
            {isMobile && !preRegister ? <MobileMenu /> : null}
            {isSigningUp ? (
              <>
                <IconButton
                  sx={{ border: '1px solid black', mr: 2 }}
                  onClick={handleBack}
                  id="backButton"
                >
                  <ArrowBackIcon sx={{ color: 'black', fontSize: { xs: '12px', md: '22px' } }} />
                </IconButton>
                <Typography
                  onClick={handleBack}
                  sx={{ display: { xs: 'none', sm: 'flex' }, cursor: 'pointer' }}
                >
                  Back
                </Typography>
              </>
            ) : null}
          </Box>

          <HeaderLogo isMobile={isMobile} />

          <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
            {isSigningUp ? (
              <Link data-variant="navItem" underline="none" href={externalConnections.signin}>
                Sign In
              </Link>
            ) : null}
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default SiteHeader;
